import { AsyncPipe } from '@angular/common';
import { Component, inject, output } from '@angular/core';

import { OVERLAY_DATA } from '@app-core/services/overlay';
import { Observable } from 'rxjs';

import { NotificationPanelData } from './notification-panel-data';
import { notificationRevealTrigger } from './notification-panel.animation';
import { NotificationComponent } from '../notification/notification.component';
import { NotificationItem } from '../notification/notification.interface';

@Component({
  templateUrl: './notification-panel.component.html',
  styleUrls: ['./notification-panel.component.scss'],
  animations: [notificationRevealTrigger],
  imports: [AsyncPipe, NotificationComponent],
})
export class NotificationPanelComponent {
  private data = inject<NotificationPanelData>(OVERLAY_DATA);

  readonly closedNotification = output<void>();

  get notifications$(): Observable<NotificationItem[]> {
    return this.data.notification.notifications$();
  }

  closeNotification(id: string): void {
    this.data.notification.remove(id);
  }

  trackByID(_: number, { id }: NotificationItem): string {
    return id;
  }
}
